import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibo el material?',
  answer: 'Todos los recursos se entregan en formato digital PDF de alta calidad. Puedes imprimirlos, proyectarlos o utilizarlos directamente desde una computadora, tableta o teléfono.'
}, {
  question: '¿Sirve para docentes de toda Latinoamérica?',
  answer: 'Sí. El material trabaja los contenidos fundamentales de química que se enseñan en educación secundaria. Cada docente puede seleccionar, organizar y adaptar los recursos de acuerdo con el programa de su país o institución.'
}, {
  question: '¿Puedo utilizarlo en clases particulares o talleres?',
  answer: 'Sí. Puedes utilizarlo en instituciones educativas, clases particulares, espacios de apoyo y talleres de ciencias. El material no puede revenderse, compartirse públicamente ni distribuirse como producto propio.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Después de confirmar el pago, recibirás en tu correo electrónico las instrucciones para acceder y descargar los archivos.'
}, {
  question: '¿El precio está en dólares?',
  answer: 'Sí. El precio es de USD 16. En el checkout, la plataforma realizará automáticamente la conversión a la moneda de tu país según el medio de pago seleccionado.'
}, {
  question: '¿El pago es seguro?',
  answer: 'Sí. La operación se realiza mediante una pasarela de pago segura y protegida. Los datos personales y financieros son procesados directamente por la plataforma de pago.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. La compra cuenta con una garantía de satisfacción de 7 días, de acuerdo con las condiciones informadas en esta página.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 md:py-12 px-4 bg-sky-200/30" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-slate-900 mb-6 md:mb-10" data-id="element-60">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-61">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-blue-100 overflow-hidden shadow-sm" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-5 md:p-6 text-left flex justify-between items-center gap-4" data-id="element-63">
                <span className="font-black text-slate-900 text-sm md:text-lg leading-tight" data-id="element-64">
                  {faq.question}
                </span>
                <div className="shrink-0 text-blue-600" data-id="element-65">
                  {openIndex === index ? <Minus size={20} data-id="element-66" /> : <Plus size={20} data-id="element-67" />}
                </div>
              </button>
              <AnimatePresence data-id="element-68">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-69">
                    <div className="px-5 md:px-6 pb-6 text-slate-600 font-medium text-xs md:text-base leading-relaxed" data-id="element-70">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}